import { useLocation, NavLink } from 'react-router-dom';
import React, { useState } from "react";
import Header from './Header';
import Footer from './Footer';

import {
    UsersRound,
    Store,
    IdCard,
    GitPullRequestCreateArrow,
    Gift,
    FileChartColumnIncreasing,
    ChevronRight,
    Gauge,
    ChevronDown
} from "lucide-react";
// import { useAuth } from '../context/AuthContext';

export default function Layout({ children }) {
    const location = useLocation();
    const { pathname } = location;
    const [openMenus, setOpenMenus] = useState({});
    const [mobileOpen, setMobileOpen] = useState(false);
    const toggle = (key) => setOpenMenus((o) => ({ ...o, [key]: !o[key] }));

    const menu = [
        { key: "dashboard", label: "Dashboard", icon: <Gauge size={18} />, to: "/" },
        {
            key: "customers",
            label: "Customers",
            icon: <UsersRound size={18} />,
            children: [
                { label: "All Customers", to: "/customer" },
                // { label: "Segments", to: "/customer/segments" },
            ],
        },
        {
            key: "stores",
            label: "Stores",
            icon: <Store size={18} />,
            children: [
                { label: "All Stores/Events", to: "/store" },
                { label: "Add Store/Event", to: "/store/add" },
            ],
        },
        {
            key: "loyalty",
            label: "Loyalty Card",
            icon: <IdCard size={18} />,
            children: [
                { label: "Loyalty Card", to: "/loyalty/loyalty_card" },
                { label: "Assign Loyalty Card", to: "/loyalty/customer_card" },
                // { label: "Loyalty Reward", to: "/loyalty/reward" },
                { label: "Loyalty Redemption", to: "/loyalty/redemption" },
                // { label: "Loyalty Points Transaction", to: "/loyalty/points_transaction" },
            ],
        },
        {
            key: "assign",
            label: "Assign Loyalty Card",
            icon: <GitPullRequestCreateArrow size={18} />,
            to: "/loyalty/customer_card",
        },
        { key: "rewards", label: "Rewards Rules", icon: <Gift size={18} />, to: "/loyalty/reward" },
        { key: "report", label: "Report", icon: <FileChartColumnIncreasing size={18} />, to: "/report" },
    ];

    const Sidebar = (
        <aside
            className={`bg-white shadow-lg w-64 fixed lg:static inset-y-0 left-0 transform transition-transform duration-200 ease-in-out z-30 ${mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
        >
            <nav className="p-4 mt-16 lg:mt-0 space-y-1 overflow-y-auto h-full pb-20 lg:pb-4">
                {menu.map((m) => (
                    <div key={m.key}>
                        {m.children ? (
                            <button
                                onClick={() => toggle(m.key)}
                                className="w-full flex items-center justify-between px-3 py-2 rounded-lg hover:bg-gray-100"
                            >
                                <span className="flex items-center gap-2 text-gray-700 text-sm font-medium">
                                    {m.icon}
                                    {m.label}
                                </span>
                                {openMenus[m.key] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                            </button>
                        ) : (
                            <NavLink
                                to={m.to}
                                onClick={() => setMobileOpen(false)}
                                className={({ isActive }) =>
                                    `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium ${isActive ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`
                                }
                            >
                                {m.icon}
                                {m.label}
                            </NavLink>
                        )}
                        {m.children && openMenus[m.key] && (
                            <div className="ml-6 mt-1 space-y-1">
                                {m.children.map((c) => (
                                    <NavLink
                                        key={c.to}
                                        to={c.to}
                                        onClick={() => setMobileOpen(false)}
                                        className={({ isActive }) =>
                                            `block px-3 py-1.5 rounded-lg text-sm ${isActive ? "bg-blue-100 text-blue-600" : "text-gray-600 hover:bg-gray-100"}`
                                        }
                                    >
                                        {c.label}
                                    </NavLink>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </nav>
        </aside>
    );

    const setMobileOpenLay = () => {
        setMobileOpen(!mobileOpen)
    }

    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            {/* Header */}
            {(pathname !== '/login') && (
                <Header setMobileOpenLay={setMobileOpenLay} />
            )}

            <div className="flex flex-1 overflow-hidden">
                {(pathname !== '/login') && (
                    <>
                        {Sidebar}
                        {/* Backdrop for mobile */}
                        {mobileOpen && (
                            <div
                                className="fixed inset-0 bg-black/30 lg:hidden z-20"
                                onClick={() => setMobileOpen(false)}
                            />
                        )}
                    </>
                )}

                {/* Main content */}
                <main className="flex-1 p-4 md:p-4 overflow-y-auto lg:ml-0">
                    {children}
                </main>
            </div>
            <Footer />
        </div>
    );
}